import React from "react";
import { getSummonerProfileContext } from "components/SummonerProfiles/SummonerProfileContext";
import PageNav from "components/PageNav";
import MediaQuery from "components/MediaQuery";
import { ReactComponent as EditIcon } from "svg/edit-icon.svg";
import { useQuery } from "@apollo/client";
import { GET_LIVE_GAME_EXISTS } from "api/graphql/queries";
import { useLightMode } from "hooks/general-hooks";

export const SummonerProfileNav = (props) => {
  const context = getSummonerProfileContext();
  const { summonerName, region } = context;
  const { data: live_game_exists_data } = useQuery(GET_LIVE_GAME_EXISTS, {
    variables: { regionId: region, summonerName },
    ssr: false,
  });

  let navTabs = [
    {
      path: `/lol/profile/${region}/${summonerName}/overview`,
      activePaths: [`/lol/profile/${region}/${summonerName}/overview`],
      label: "Overview",
      reset: true,
    },
    {
      path: `/lol/profile/${region}/${summonerName}/champion-stats`,
      label: "Champion Stats",
    },
    {
      path: `/lol/profile/${region}/${summonerName}/live-game`,
      label: "Live Game",
      liveIcon: live_game_exists_data && live_game_exists_data.liveGameExists,
    },
  ];

  return <PageNav tabs={navTabs} />;
};

const SummonerProfileNavContainer = (props) => {
  const context = getSummonerProfileContext();
  const { summonerName, region, userVerified, isSameSummoner, setIsModalOpen } = context;
  const { lightModeOn } = useLightMode();

  return (
    <div className="navigation-container">
      <SummonerProfileNav />
      <MediaQuery min="TABLET" max="DESKTOP_LARGE">
        {userVerified && isSameSummoner && !lightModeOn && (
          <div
            className="edit-button"
            onClick={() => {
              setIsModalOpen(true);
            }}
            data-summoner={summonerName.toLowerCase()}
            data-region={region}
          >
            <EditIcon className="edit-icon" />
            <div className="edit-text">Edit</div>
          </div>
        )}
      </MediaQuery>
    </div>
  );
};

export default SummonerProfileNavContainer;
